import * as actionTypes from './actionTypes';


export const loadClientStyleStyleSuccess = (response)=>{
    return {
        type:actionTypes.LOAD_CLIENT_STYLE_SUCCESS,
        response
    }
};

export const loadClientStyleStyleFailed = (error)=>{
    return {
        type:actionTypes.LOAD_CLIENT_STYLE_FAILED,
        error
    }
};

export const loadClientStyleStart  = (Id, skipStatusCheck) =>{
    return  {
        type: actionTypes.LOAD_CLIENT_STYLE,
        sessionId:Id,
        skipStatusCheck
    };
};